import { Directive, ElementRef, Input, Renderer2, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { GridComponent } from '@progress/kendo-angular-grid';
@Directive({
    selector: '[farrisDisabled]'
})
export class FarrisDisabledDirective implements OnInit, OnChanges {
    @Input('farrisDisabled') kendoGridDisabled: boolean;
    maskElement: any;
    constructor(private grid: GridComponent, private el: ElementRef, private renderer: Renderer2) {

    }
    ngOnInit() {

    }
    ngOnChanges(changes: SimpleChanges) {
        if (!this.maskElement) {
            this.createMaskElement();
        }
        if (changes['kendoGridDisabled'] && this.maskElement) {
            if (this.kendoGridDisabled) {
                this.renderer.removeStyle(this.maskElement, 'display');
            } else {
                this.renderer.setStyle(this.maskElement, 'display', 'none');
            }
        }
    }
    private createMaskElement() {
        this.maskElement = this.renderer.createElement("div");
        this.renderer.setStyle(this.maskElement, 'width', '100%');
        this.renderer.setStyle(this.maskElement, 'height', '100%');
        this.renderer.setStyle(this.maskElement, 'position', 'absolute');
        this.renderer.setStyle(this.maskElement, 'background-color', 'rgba(255,255,255,0.5)');
        this.renderer.setStyle(this.maskElement, 'z-index', '3');
        this.renderer.setStyle(this.maskElement, 'display', 'none');
        this.renderer.appendChild(this.el.nativeElement, this.maskElement);
    }
}

